// source: galaxycompletepb/apipb/domainpb/integration.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var galaxycompletepb_apipb_domainpb_user_pb = require('../../../galaxycompletepb/apipb/domainpb/user_pb.js');
goog.object.extend(proto, galaxycompletepb_apipb_domainpb_user_pb);
goog.exportSymbol('proto.galaxycomplete.domain.IntegrationConfigInfo', null, global);
goog.exportSymbol('proto.galaxycomplete.domain.IntegrationModule', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.galaxycomplete.domain.IntegrationConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.galaxycomplete.domain.IntegrationConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.galaxycomplete.domain.IntegrationConfigInfo.displayName = 'proto.galaxycomplete.domain.IntegrationConfigInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.galaxycomplete.domain.IntegrationConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.galaxycomplete.domain.IntegrationConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    module: jspb.Message.getFieldWithDefault(msg, 2, 0),
    friendlyName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    enabledBy: (f = msg.getEnabledBy()) && galaxycompletepb_apipb_domainpb_user_pb.HubUser.toObject(includeInstance, f),
    enabledAt: (f = msg.getEnabledAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    properties: (f = msg.getProperties()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    verboseLogging: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.galaxycomplete.domain.IntegrationConfigInfo;
  return proto.galaxycomplete.domain.IntegrationConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.galaxycomplete.domain.IntegrationConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.galaxycomplete.domain.IntegrationModule} */ (reader.readEnum());
      msg.setModule(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFriendlyName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 10:
      var value = new galaxycompletepb_apipb_domainpb_user_pb.HubUser;
      reader.readMessage(value,galaxycompletepb_apipb_domainpb_user_pb.HubUser.deserializeBinaryFromReader);
      msg.setEnabledBy(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEnabledAt(value);
      break;
    case 12:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setProperties(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerboseLogging(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.galaxycomplete.domain.IntegrationConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.galaxycomplete.domain.IntegrationConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getModule();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFriendlyName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEnabledBy();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      galaxycompletepb_apipb_domainpb_user_pb.HubUser.serializeBinaryToWriter
    );
  }
  f = message.getEnabledAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProperties();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getVerboseLogging();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional IntegrationModule module = 2;
 * @return {!proto.galaxycomplete.domain.IntegrationModule}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getModule = function() {
  return /** @type {!proto.galaxycomplete.domain.IntegrationModule} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.galaxycomplete.domain.IntegrationModule} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setModule = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string friendly_name = 3;
 * @return {string}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getFriendlyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setFriendlyName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional HubUser enabled_by = 10;
 * @return {?proto.galaxycomplete.domain.HubUser}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getEnabledBy = function() {
  return /** @type{?proto.galaxycomplete.domain.HubUser} */ (
    jspb.Message.getWrapperField(this, galaxycompletepb_apipb_domainpb_user_pb.HubUser, 10));
};


/**
 * @param {?proto.galaxycomplete.domain.HubUser|undefined} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
*/
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setEnabledBy = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.clearEnabledBy = function() {
  return this.setEnabledBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.hasEnabledBy = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp enabled_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getEnabledAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
*/
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setEnabledAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.clearEnabledAt = function() {
  return this.setEnabledAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.hasEnabledAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Struct properties = 12;
 * @return {?proto.google.protobuf.Struct}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getProperties = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 12));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
*/
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setProperties = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.clearProperties = function() {
  return this.setProperties(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.hasProperties = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool active = 13;
 * @return {boolean}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool verbose_logging = 14;
 * @return {boolean}
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.getVerboseLogging = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.galaxycomplete.domain.IntegrationConfigInfo} returns this
 */
proto.galaxycomplete.domain.IntegrationConfigInfo.prototype.setVerboseLogging = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * @enum {number}
 */
proto.galaxycomplete.domain.IntegrationModule = {
  UNKNOWN: 0,
  AWS: 1,
  AZURE: 2,
  PURE: 10,
  DGS: 11,
  NETAPP: 12,
  FC_PURE: 13,
  POWERSTORE: 14,
  FC_POWERSTORE: 15,
  FC_POWERMAX: 16,
  AWS_FSX_NETAPP: 17,
  GCP: 18,
  ORACLE: 19,
  SILKSDP: 20,
  DIGITALOCEAN: 21
};

goog.object.extend(exports, proto.galaxycomplete.domain);
